import isString from 'lodash/isString'
import { jwtDecode, toDate } from './index'

const currentTime = () => new Date().getTime() / 1000

function isExpired(token)
{
	if ( isString(token) )
	{
		token = jwtDecode(token)
	}

	const { exp } = token ?? {}

	return currentTime() > exp
}

export default isExpired